import type { SavedChartSummary } from './localPersistence.js';

export interface SavedChartDisplayViewModel {
  alias: string;
  savedAt: string;
  ruleset: string;
  chronology?: string;
  chronologyValidationStatus?: SavedChartSummary['chronologyValidationStatus'];
  birthDetailsVisible: boolean;
  solarDate?: string;
  lunarDate?: string;
  timeLabel?: string;
  disclosure: string;
}

export function savedChartDisplayViewModel(
  summary: SavedChartSummary,
  revealBirthDetails = false,
): SavedChartDisplayViewModel {
  return Object.freeze({
    alias: summary.alias ?? '未命名命盤',
    savedAt: summary.savedAt,
    ruleset: summary.ruleset,
    ...(summary.chronology ? { chronology: summary.chronology } : {}),
    ...(summary.chronologyValidationStatus ? { chronologyValidationStatus: summary.chronologyValidationStatus } : {}),
    birthDetailsVisible: revealBirthDetails,
    ...(revealBirthDetails ? {
      solarDate: summary.solarDate,
      lunarDate: summary.lunarDate,
      timeLabel: summary.timeLabel,
    } : {}),
    disclosure: revealBirthDetails
      ? '出生日期與時辰目前已顯示；這些資料只來自本機保存紀錄。'
      : '出生日期與時辰預設隱藏；需要時再由使用者主動展開。',
  });
}
